import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';

export type FilterType = {
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};
export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

export const exportHeaders = [
  'STT',
  'Mã giao dịch',
  'Người được giới thiệu',
  'Người giới thiệu',
  'Mã giới thiệu',
  'Số tiền',
  'Thời gian',
  'Trạng thái',
  'Lỗi',
];
